import { useEffect } from "react";

const BannerHyfye = () => {
  useEffect(() => {
    const canvas = document.getElementById("banner_canvas");
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let w = window.innerWidth;
    let h = window.innerHeight;
    canvas.width = w;
    canvas.height = h;

    const rate = 60;
    const arc = 200;
    const size = 7;
    const speed = 20;
    const colors = ['#FFC56E','#FF6CC6','#4241B8','#F69040','#0EADC9'];
    const mouse = { x: 0, y: 0 };
    let time = 0;
    let parts = [];

    function createParticles() {
      parts = [];
      for (let i = 0; i < arc; i++) {
        parts.push({
          x: Math.random() * w,
          y: Math.random() * h,
          toX: Math.random() * 5 - 1,
          toY: Math.random() * 2 - 1,
          c: colors[Math.floor(Math.random() * colors.length)],
          size: Math.random() * size,
        });
      }
    }

    function drawParticles() {
      ctx.clearRect(0, 0, w, h);
      for (let i = 0; i < arc; i++) {
        const p = parts[i];
        const distance = distanceBetween(mouse, p);
        const distanceFactor = Math.max(Math.min(15 - distance / 10, 10), 1);

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size * distanceFactor, 0, Math.PI * 2);
        ctx.fillStyle = p.c;
        ctx.strokeStyle = p.c;
        if (i % 2 === 0) ctx.stroke();
        else ctx.fill();

        p.x += p.toX * (time * 0.05);
        p.y += p.toY * (time * 0.05);

        if (p.x > w) p.x = 0;
        if (p.y > h) p.y = 0;
        if (p.x < 0) p.x = w;
        if (p.y < 0) p.y = h;
      }

      if (time < speed) time++;
      requestAnimationFrame(drawParticles);
    }

    function distanceBetween(p1, p2) {
      const dx = p2.x - p1.x;
      const dy = p2.y - p1.y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function handleMouseMove(e) {
      mouse.x = e.layerX;
      mouse.y = e.layerY;
    }

    window.addEventListener("mousemove", handleMouseMove);
    createParticles();
    drawParticles();

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };

  }, []);


    return (
  <section id="home_section" className="section_banner bg_black_dark wp_pattern d-flex align-items-center overflow_hide bg-animated bgg-1">
    <canvas id="banner_canvas" className="transparent_effect"></canvas>
    <div className="container">
      <div className="row align-items-center">
  
        {/* Left Side Content */}
        <div className="col-lg-6 col-md-12 col-sm-12 order-lg-first">
          <div className="banner_text text_md_center">
            
              <h1 className="animation text-white" data-animation="fadeInUp" data-animation-delay="0.1s">
               Welcome to <img loading="lazy" className='logo_light App-logo' src='https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/web/logo-dark-small.png' alt='logo'/>yfye —
                <p className="whitecolor" id="subtitle"><span className="standout">HY</span>BRID <span className="standout">F</span>INANCE FOR <span className="standout">Y</span>OU & <span className="standout">E</span>VERYONE</p>
            </h1>
         <br/>
            <p className="animation text-white" data-animation="fadeInUp" data-animation-delay="0.1s">
              <strong className="font-h2">Phase 1: Launching Hyfye Coin (HYE)</strong> —  <br/> A revolutionary digital currency designed to raise early support and build community. We’re starting with a 500 BNB hard cap fundraising round on PinkSale to kickstart development.
            </p>
  
            <p className="animation text-white" data-animation="fadeInUp" data-animation-delay="0.1s">
              <strong className="font-h2">Phase 2: The Hyfye Ecosystem Comes Alive</strong> — <br/> Get ready for powerful, lightweight mini apps and browser extensions that let you earn Hyfye through real engagement. From decentralized finance tools, content creation platforms, advertising systems, and global marketplaces to immersive sports, online games, and fitness apps — Hyfye fuels the future of hybrid digital economies. Wherever action happens, value flows. This isn’t just a platform, it’s a new earning layer for the internet.
            </p>
  
            <div className="btn_group animation" data-animation="fadeInUp" data-animation-delay="0.1s">
              <a href="https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/document/Hyfye-official-whitepaper.pdf" className="btn btn-default nav-link content-popup" target="_blank" download>
                <i className="fa fa-file-word-o"></i>Whitepaper
              </a>
              <a href="https://www.pinksale.finance/launchpad/bsc/0x5de2d1644cbde0db29b8Ab81CaD2A85e4ccfeD36" disabled className="btn btn-border-white" target="_blank">
                <i className="fa fa-ge"></i>Buy Token
              </a>
             
            </div>
  
            {/* Hidden Whitepaper Popup */}
            <div id="whitepaper" className="team_pop mfp-hide">
              <div className="row m-0">
                <div className="col-md-7">
                  <div className="pt-3 pb-3">
                    <div className="title_dark title_border">
                      <h4>Download Whitepaper</h4>
                      <p>
                        Understand Hyfye's mission, tokenomics, future roadmap, and how we are building the next decentralized global economy of gratitude.
                      </p>
                      <a href="https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/document/Hyfye-official-whitepaper.pdf" className="btn btn-default" download>
                        Download Now <i className="ion-ios-arrow-thin-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
               
              </div>
            </div>
  
          </div>
        </div>
  
        {/* Right Side Token Progress */}
       
  
      </div>
  
      {/* Divider */}
      <div className="row">
        <div className="col-12">
          <div className="divider small_divider"></div>
        </div>
      </div>
  
      {/* Accepted Crypto Section */}
      <div className="row">
        <div className="col-md-12 text_sm_center">
          <span className="text-white icon_title animation" data-animation="fadeInUp" data-animation-delay="0.1s">
            Currently Accepting:
          </span>
          <ul className="list_none currency_icon">
            <li className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
              <i className="cc BC"></i><span>BNB (Binance Smart Chain - BEP-20)</span>
            </li>
            <li className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
              <i className="cc USDT"></i><span>USDT (BEP-20)</span>
            </li>
             
             <li className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
               <a href="https://bscscan.com/token/0xbF35945D28ff93dE8786E10Aa8e716524f43628b"  className="currency-home btn-default"  target="_blank">
                <i className="fa fa-home"></i>Token Address: 0xbF35945D28ff93dE8786E10Aa8e716524f43628b
              </a>
               
            </li>
            
          </ul>
        </div>
       
      </div>
   <div className="row">
         
             <div className="col-lg-5 col-md-8  col-sm-12 order-first">
            
          <div className="banner_inner res_md_mb_50 res_xs_mb_30">
            <div className="tk_countdown  tk_border_white rounded-0 text-center animation" data-animation="fadeIn" data-animation-delay="0.1s">
              <div className="banner_text tk_counter_inner">
                <div className="tk_countdown_time p-0  box_shadow_none animation" data-animation="fadeInUp" data-animation-delay="0.1s"></div>
                <div className="progress animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                  <div className="progress-bar progress-bar-striped gradient" role="progressbar" aria-valuenow="0.01" aria-valuemin="0" aria-valuemax="100" style={{ width: "15%" }}>
                    0%
                  </div>
                  <span className="progress_label bg-white" style={{ left: "3%" }}><strong>0% Raised</strong></span>
                  <span className="progress_label bg-white" style={{ left: "98%" }}><strong>Soft Cap Target</strong></span>
                  <span className="progress_min_val">Sale Raised</span>
                  <span className="progress_max_val">Soft Cap</span>
                </div>
              </div>
            </div>
          </div>
        
          </div>
        </div>
      {/* Divider */}
      <div className="row">
        <div className="col-12">
          <div className="divider small_divider"></div>
        </div>
      </div>
  
    </div>
  </section>

  
  )};
  
  export default BannerHyfye;
  